module.exports = __webpack_public_path__ + "media/images/talent/voice-thum03-7cc8a7b0b04aa5f5aadd1b0408638323.png";